import { Box, Stack, Typography } from "@mui/material"
import type { ReactNode } from "react"

type ReportPageHeaderProps = {
  title: string
  description: string
  action?: ReactNode
}

export function ReportPageHeader({
  title,
  description,
  action,
}: ReportPageHeaderProps) {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", md: "flex-start" }}
      spacing={2}
    >
      <Stack spacing={1} sx={{ maxWidth: 960 }}>
        <Typography variant="h1">{title}</Typography>
        <Typography variant="body1" color="textSecondary">
          {description}
        </Typography>
      </Stack>

      {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
    </Stack>
  )
}
